var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "b-row",
        [
          _vm.tb != "1"
            ? _c(
                "b-col",
                { staticClass: "form-group", attrs: { sm: "6" } },
                [
                  _c("form-write-group-label-input", {
                    attrs: {
                      isMandatory: "",
                      disabled: _vm.readonly,
                      inputLabel: _vm.$t("common.routing.config_name"),
                      placeholderValue: _vm.$t("common.routing.config_name"),
                    },
                    model: {
                      value: _vm.name,
                      callback: function ($$v) {
                        _vm.name = $$v
                      },
                      expression: "name",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "b-col",
            { staticClass: "form-group", attrs: { sm: "6" } },
            [
              _vm.tb == "1"
                ? _c("form-read-group-label-input", {
                    attrs: {
                      inputValue: _vm.host,
                      inputLabel: _vm.$t("common.routing.host"),
                      placeholderValue: _vm.$t("common.routing.host"),
                    },
                  })
                : _c("form-write-group-label-input", {
                    attrs: {
                      disabled: "",
                      isMandatory: _vm.tb == "1",
                      inputLabel: _vm.$t("common.routing.host"),
                      placeholderValue: _vm.$t("common.routing.host"),
                    },
                    model: {
                      value: _vm.host,
                      callback: function ($$v) {
                        _vm.host = $$v
                      },
                      expression: "host",
                    },
                  }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            { staticClass: "form-group", attrs: { sm: "6" } },
            [
              _vm.tb == "1"
                ? _c("form-read-group-label-input", {
                    attrs: {
                      inputValue: _vm.port,
                      inputLabel: _vm.$t("common.routing.port"),
                      placeholderValue: _vm.$t("common.routing.port"),
                    },
                  })
                : _c("form-write-group-label-input", {
                    attrs: {
                      isMandatory: "",
                      disabled: _vm.readonly || _vm.tb == "1",
                      inputLabel: _vm.$t("common.routing.port"),
                      placeholderValue: _vm.$t("common.routing.port"),
                    },
                    model: {
                      value: _vm.port,
                      callback: function ($$v) {
                        _vm.port = $$v
                      },
                      expression: "port",
                    },
                  }),
            ],
            1
          ),
          _vm._v(" "),
          _vm.tb != "1"
            ? _c(
                "b-col",
                { staticClass: "form-group", attrs: { sm: "6" } },
                [
                  _c("form-write-group-label-input", {
                    attrs: {
                      isMandatory: "",
                      disabled: _vm.readonly,
                      inputLabel: _vm.$t("common.routing.timeout"),
                      placeholderValue: _vm.$t("common.routing.timeout"),
                    },
                    model: {
                      value: _vm.timeout,
                      callback: function ($$v) {
                        _vm.timeout = $$v
                      },
                      expression: "timeout",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.formatName != "" && _vm.formatOutName != "" && _vm.tb != "1"
            ? _c(
                "b-col",
                { staticClass: "form-group", attrs: { sm: "6" } },
                [
                  _c("form-write-group-label-input", {
                    attrs: {
                      disabled: "",
                      inputLabel: _vm.$t("common.routing.format_name"),
                      placeholderValue: _vm.$t("common.routing.format_name"),
                    },
                    model: {
                      value: _vm.formatName,
                      callback: function ($$v) {
                        _vm.formatName = $$v
                      },
                      expression: "formatName",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.tb == "1"
            ? _c(
                "b-col",
                { staticClass: "form-group mt-4", attrs: { sm: "6" } },
                [
                  _c("span", { staticClass: "my-2" }, [
                    _c("span", { staticClass: "filter-item-title" }, [
                      _vm._v(
                        _vm._s(_vm.$t("certificates.details_certificate"))
                      ),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "color-red" }, [_vm._v("* ")]),
                  ]),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    {
                      class: _vm.CertificateInput ? "my-2" : "pl-0",
                      attrs: { sm: "12", disabled: _vm.readonly },
                    },
                    [
                      _c(
                        "b-col",
                        { attrs: { sm: "12 p-0 my-3" } },
                        [
                          _c(
                            "b-row",
                            { staticClass: "m-0" },
                            [
                              _c(
                                "b-col",
                                [
                                  _c("form-write-group-label-input", {
                                    attrs: {
                                      inputLabel: _vm.$t(
                                        "certificates.organisation_identifier"
                                      ),
                                      placeholderValue: _vm.$t(
                                        "certificates.organisation_identifier"
                                      ),
                                    },
                                    on: {
                                      input: function ($event) {
                                        return _vm.resetFieldForm()
                                      },
                                    },
                                    model: {
                                      value: _vm.OrganisationIdentifier,
                                      callback: function ($$v) {
                                        _vm.OrganisationIdentifier = $$v
                                      },
                                      expression: "OrganisationIdentifier",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                [
                                  _c("form-write-group-label-input", {
                                    attrs: {
                                      inputLabel: _vm.$t(
                                        "administration.country"
                                      ),
                                      placeholderValue: _vm.$t(
                                        "administration.country"
                                      ),
                                    },
                                    on: {
                                      input: function ($event) {
                                        return _vm.resetFieldForm()
                                      },
                                    },
                                    model: {
                                      value: _vm.Country,
                                      callback: function ($$v) {
                                        _vm.Country = $$v
                                      },
                                      expression: "Country",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.hasMainFile
                            ? _c("div", { staticClass: "mt-2" }, [
                                _c("label", { staticClass: "ml-3" }, [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.isStandard,
                                        expression: "isStandard",
                                      },
                                    ],
                                    attrs: { type: "checkbox" },
                                    domProps: {
                                      checked: Array.isArray(_vm.isStandard)
                                        ? _vm._i(_vm.isStandard, null) > -1
                                        : _vm.isStandard,
                                    },
                                    on: {
                                      change: [
                                        function ($event) {
                                          var $$a = _vm.isStandard,
                                            $$el = $event.target,
                                            $$c = $$el.checked ? true : false
                                          if (Array.isArray($$a)) {
                                            var $$v = null,
                                              $$i = _vm._i($$a, $$v)
                                            if ($$el.checked) {
                                              $$i < 0 &&
                                                (_vm.isStandard = $$a.concat([
                                                  $$v,
                                                ]))
                                            } else {
                                              $$i > -1 &&
                                                (_vm.isStandard = $$a
                                                  .slice(0, $$i)
                                                  .concat($$a.slice($$i + 1)))
                                            }
                                          } else {
                                            _vm.isStandard = $$c
                                          }
                                        },
                                        _vm.emitValidity,
                                      ],
                                    },
                                  }),
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(_vm.$t("certificates.qwac_psd2")) +
                                      "\n              "
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("label", [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.isQwacLike,
                                        expression: "isQwacLike",
                                      },
                                    ],
                                    attrs: { type: "checkbox" },
                                    domProps: {
                                      checked: Array.isArray(_vm.isQwacLike)
                                        ? _vm._i(_vm.isQwacLike, null) > -1
                                        : _vm.isQwacLike,
                                    },
                                    on: {
                                      change: [
                                        function ($event) {
                                          var $$a = _vm.isQwacLike,
                                            $$el = $event.target,
                                            $$c = $$el.checked ? true : false
                                          if (Array.isArray($$a)) {
                                            var $$v = null,
                                              $$i = _vm._i($$a, $$v)
                                            if ($$el.checked) {
                                              $$i < 0 &&
                                                (_vm.isQwacLike = $$a.concat([
                                                  $$v,
                                                ]))
                                            } else {
                                              $$i > -1 &&
                                                (_vm.isQwacLike = $$a
                                                  .slice(0, $$i)
                                                  .concat($$a.slice($$i + 1)))
                                            }
                                          } else {
                                            _vm.isQwacLike = $$c
                                          }
                                        },
                                        _vm.emitValidity,
                                      ],
                                    },
                                  }),
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        _vm.$t(
                                          "certificates.qwac_psd2_mimicked"
                                        )
                                      ) +
                                      "\n              "
                                  ),
                                ]),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.isQwacLike
                            ? _c("div", [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "ml-2 alert d-flex align-items-center",
                                    staticStyle: {
                                      color: "#000000",
                                      "background-color": "rgb(236,236,236)",
                                    },
                                    attrs: { disabled: "", role: "alert" },
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          _vm.$t(
                                            "certificates.qwac_psd2_mimicked_info"
                                          )
                                        ) +
                                        "\n              "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c("input", {
                                  attrs: { type: "file", accept: ".pem" },
                                  on: { change: _vm.handleFileUploadAC },
                                }),
                              ])
                            : _vm._e(),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("br"),
                      _vm._v(" "),
                      _vm.ACFile
                        ? _c(
                            "div",
                            { staticClass: "certificate-details" },
                            [
                              _c("span", [
                                _c(
                                  "span",
                                  { staticClass: "filter-item-title" },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("certificates.details_ca_client")
                                      )
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c("span", { staticClass: "color-red" }, [
                                  _vm._v("* "),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("br"),
                              _vm._v(" "),
                              _vm.ACFile
                                ? _c(
                                    "b-col",
                                    {
                                      staticClass: "certificate-details",
                                      attrs: { sm: "12" },
                                    },
                                    [
                                      _c(
                                        "b-row",
                                        {
                                          staticClass:
                                            "d-flex justify-content-center align-items-center",
                                        },
                                        [
                                          _c("b-col", { attrs: { sm: "12" } }, [
                                            _c(
                                              "details",
                                              { staticClass: "mt-4" },
                                              [
                                                _c(
                                                  "summary",
                                                  {
                                                    staticClass:
                                                      "w-50 btn btn-primary d-inline-block px-3 py-2 rounded",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "certificates.view_ca_certificates"
                                                        )
                                                      )
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "pre",
                                                  {
                                                    staticClass:
                                                      "p-2 bg-light text-monospace",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(_vm.decodeACFile())
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ]),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { staticClass: "my-3 p-0", attrs: { sm: "6" } },
                        [
                          !_vm.readonly
                            ? _c(
                                "b-button",
                                {
                                  staticClass:
                                    "justify-item-end responsive-button",
                                  attrs: { variant: "primary" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.openPopup("output")
                                    },
                                  },
                                },
                                [
                                  _c("i", { staticClass: "fa-light fa-plus" }),
                                  _vm._v(" "),
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "entities_setting_tb.generate_certificat"
                                        )
                                      )
                                    ),
                                  ]),
                                ]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.showModal
                        ? _c("certificate-pop-up", {
                            attrs: { form: _vm.form },
                            on: {
                              close: _vm.closePopup,
                              savepopup: _vm.submitForm,
                            },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _c("br"),
                      _vm._v(" "),
                      _vm.CertificateInput
                        ? _c(
                            "b-col",
                            { staticClass: "p-0", attrs: { sm: "12" } },
                            [
                              _c(
                                "b-row",
                                { staticClass: "m-0" },
                                [
                                  _vm.CertificateInput
                                    ? _c(
                                        "b-col",
                                        {
                                          staticClass: "p-0",
                                          attrs: { sm: "2" },
                                        },
                                        [
                                          _vm.CertificateInput.deliveredTo !==
                                          ""
                                            ? _c(
                                                "form-read-group-label-input",
                                                {
                                                  attrs: {
                                                    inputLabel: _vm.$t(
                                                      "certificates.common_name"
                                                    ),
                                                    inputValue:
                                                      _vm.CertificateInput
                                                        .deliveredTo,
                                                  },
                                                }
                                              )
                                            : _vm._e(),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.CertificateInput
                                    ? _c(
                                        "b-col",
                                        {
                                          staticClass: "p-0",
                                          attrs: { sm: "2" },
                                        },
                                        [
                                          _vm.CertificateInput.deliveredBy !==
                                          ""
                                            ? _c(
                                                "form-read-group-label-input",
                                                {
                                                  attrs: {
                                                    inputLabel: _vm.$t(
                                                      "certificates.issued_by"
                                                    ),
                                                    inputValue:
                                                      _vm.CertificateInput
                                                        .deliveredBy,
                                                  },
                                                }
                                              )
                                            : _vm._e(),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.CertificateInput
                                    ? _c(
                                        "b-col",
                                        {
                                          staticClass: "p-0",
                                          attrs: { sm: "2" },
                                        },
                                        [
                                          _vm.CertificateInput.startDate !== ""
                                            ? _c(
                                                "form-read-group-label-input",
                                                {
                                                  attrs: {
                                                    inputLabel: _vm.$t(
                                                      "certificates.valid_from"
                                                    ),
                                                    inputValue:
                                                      _vm.CertificateInput
                                                        .startDate,
                                                  },
                                                }
                                              )
                                            : _vm._e(),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.CertificateInput
                                    ? _c(
                                        "b-col",
                                        {
                                          staticClass: "p-0",
                                          attrs: { sm: "2" },
                                        },
                                        [
                                          _vm.CertificateInput.endDate !== ""
                                            ? _c(
                                                "form-read-group-label-input",
                                                {
                                                  attrs: {
                                                    inputLabel: _vm.$t(
                                                      "certificates.valid_until"
                                                    ),
                                                    inputValue:
                                                      _vm.CertificateInput
                                                        .endDate,
                                                  },
                                                }
                                              )
                                            : _vm._e(),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _c(
                            "b-col",
                            { staticClass: "p-0", attrs: { sm: "12" } },
                            [
                              _c(
                                "b-row",
                                { staticClass: "m-0" },
                                [
                                  _c(
                                    "b-col",
                                    { staticClass: "p-0", attrs: { sm: "12" } },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "d-flex justify-content-left",
                                        },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "noResult" },
                                            [
                                              _vm._v(
                                                "\n                        " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "common.no_certificate"
                                                    )
                                                  ) +
                                                  "\n                      "
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        { staticClass: "mx-1" },
                        [
                          _vm.CertificateInput
                            ? _c(
                                "b-col",
                                { staticClass: "p-0", attrs: { sm: "6" } },
                                [
                                  _c("details", { staticClass: "mt-3 w-100" }, [
                                    _c(
                                      "summary",
                                      {
                                        staticClass:
                                          "w-75 btn btn-primary d-inline-block px-3 py-2 rounded",
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "certificates.view_certificate"
                                            )
                                          )
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "pre",
                                      {
                                        staticClass:
                                          "p-2 bg-light text-monospace",
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.CertificateInput.certificate
                                          )
                                        ),
                                      ]
                                    ),
                                  ]),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.CertificateInput
                            ? _c(
                                "b-col",
                                {
                                  staticClass: "p-0 d-flex justify-content-end",
                                  attrs: { sm: "6" },
                                },
                                [
                                  _vm.CertificateInput.certificate
                                    ? _c(
                                        "b-button",
                                        {
                                          staticClass:
                                            "mt-3 px-3 py-2 d-inline-block w-75",
                                          attrs: { variant: "primary" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.downloadCertificate(
                                                _vm.CertificateInput.certificate
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(
                                                _vm.$t(
                                                  "certificates.download_certificate"
                                                )
                                              ) +
                                              "\n              "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.tb == "1"
            ? _c(
                "b-col",
                {
                  staticClass: "form-group d-flex flex-column mt-4",
                  attrs: { sm: "6" },
                },
                [
                  _c("br"),
                  _vm._v(" "),
                  _vm.CAServer
                    ? _c(
                        "div",
                        { staticClass: "certificate-details" },
                        [
                          _c("span", [
                            _c("span", { staticClass: "filter-item-title" }, [
                              _vm._v(
                                _vm._s(_vm.$t("certificates.details_ca_server"))
                              ),
                            ]),
                            _vm._v(" "),
                            _c("span", { staticClass: "color-red" }, [
                              _vm._v("* "),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(" "),
                          _vm.CertificatServerParsed
                            ? _c(
                                "b-col",
                                {
                                  staticClass: "certificate-details",
                                  attrs: { sm: "12" },
                                },
                                [
                                  _c(
                                    "b-row",
                                    {
                                      staticClass:
                                        "d-flex justify-content-center align-items-center",
                                    },
                                    [
                                      _c("b-col", { attrs: { sm: "12" } }, [
                                        _c("details", { staticClass: "mt-4" }, [
                                          _c(
                                            "summary",
                                            {
                                              staticClass:
                                                "w-50 btn btn-primary d-inline-block px-3 py-2 rounded",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "certificates.view_ca_certificates"
                                                  )
                                                )
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "pre",
                                            {
                                              staticClass:
                                                "p-2 bg-light text-monospace",
                                            },
                                            [_vm._v(_vm._s(_vm.CAServer))]
                                          ),
                                        ]),
                                      ]),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      )
                    : _vm._e(),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.showModal && _vm.tb == "1"
            ? _c("certificate-pop-up", {
                attrs: { form: _vm.form },
                on: { close: _vm.closePopup, savepopup: _vm.submitForm },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.tb != "1"
            ? _c("b-col", { staticClass: "form-group", attrs: { sm: "6" } }, [
                _c("label", { attrs: { for: "ssl-active" } }, [
                  _vm._v(
                    "\n          " + _vm._s(_vm.$t("common.routing.ssl_active"))
                  ),
                  _c("span", { staticClass: "color-red" }, [_vm._v(" * ")]),
                ]),
                _vm._v(" "),
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.sslActive,
                        expression: "sslActive",
                      },
                    ],
                    staticClass: "form-control",
                    attrs: { disabled: _vm.readonly, id: "ssl-active" },
                    on: {
                      change: function ($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function (o) {
                            return o.selected
                          })
                          .map(function (o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.sslActive = $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      },
                    },
                  },
                  [
                    _vm.sslActive != "0"
                      ? _c("option", { domProps: { value: _vm.sslActive } }, [
                          _vm._v(
                            " " + _vm._s(_vm.$t("common.routing.yes")) + " "
                          ),
                        ])
                      : _c("option", { attrs: { value: "1" } }, [
                          _vm._v(
                            " " + _vm._s(_vm.$t("common.routing.yes")) + " "
                          ),
                        ]),
                    _vm._v(" "),
                    _c("option", { attrs: { value: "0" } }, [
                      _vm._v(" " + _vm._s(_vm.$t("common.routing.no")) + " "),
                    ]),
                  ]
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.sslActive != "0" && _vm.tb != "1"
            ? _c("b-col", { staticClass: "form-group", attrs: { sm: "6" } }, [
                _c("label", { attrs: { for: "keystore" } }, [
                  _vm._v(
                    "\n          " + _vm._s(_vm.$t("common.routing.keystore"))
                  ),
                  _c("span", { staticClass: "color-red" }, [_vm._v(" * ")]),
                ]),
                _vm._v(" "),
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.keystore,
                        expression: "keystore",
                      },
                    ],
                    staticClass: "form-control",
                    attrs: { disabled: _vm.readonly, id: "keystore" },
                    on: {
                      change: function ($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function (o) {
                            return o.selected
                          })
                          .map(function (o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.keystore = $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      },
                    },
                  },
                  _vm._l(_vm.keystoreList, function (keystore) {
                    return _c(
                      "option",
                      { key: keystore.id, domProps: { value: keystore.id } },
                      [_vm._v(" " + _vm._s(keystore.name) + " ")]
                    )
                  }),
                  0
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.sslActive != "0" && _vm.tb != "1"
            ? _c("b-col", { staticClass: "form-group", attrs: { sm: "6" } }, [
                _c("label", { attrs: { for: "ca" } }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.$t("common.routing.certificat")) +
                      "\n"
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.ca,
                        expression: "ca",
                      },
                    ],
                    staticClass: "form-control",
                    attrs: { disabled: _vm.readonly, id: "ca" },
                    on: {
                      change: function ($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function (o) {
                            return o.selected
                          })
                          .map(function (o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.ca = $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      },
                    },
                  },
                  _vm._l(_vm.caList, function (ca) {
                    return _c(
                      "option",
                      { key: ca.id, domProps: { value: ca.id } },
                      [_vm._v(" " + _vm._s(ca.name) + " ")]
                    )
                  }),
                  0
                ),
              ])
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _vm.sslActive === "1" && _vm.tb != "1"
        ? _c("level-control-form", {
            attrs: {
              mode: _vm.mode,
              readonly: _vm.readonly,
              placementLevel: _vm.placementWebService,
            },
            model: {
              value: _vm.controlConfig,
              callback: function ($$v) {
                _vm.controlConfig = $$v
              },
              expression: "controlConfig",
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.ExtractDataFromCertificat !== "" && _vm.tb != "1"
        ? _c(
            "form-accordion",
            {
              attrs: {
                title: _vm.$t("common.global.authentification_certificat"),
                isTitleUpperCase: false,
              },
            },
            [
              _c(
                "b-row",
                { staticClass: "form-group" },
                [
                  _c(
                    "b-col",
                    { staticClass: "form-group", attrs: { sm: "6" } },
                    [
                      _c("form-write-group-label-input", {
                        attrs: {
                          isMandatory: "",
                          disabled: "",
                          inputLabel: _vm.$t(
                            "common.routing.extract_data_from_certificat"
                          ),
                          placeholderValue: _vm.$t(
                            "common.routing.extract_data_from_certificat"
                          ),
                        },
                        model: {
                          value: _vm.ExtractDataFromCertificat,
                          callback: function ($$v) {
                            _vm.ExtractDataFromCertificat = $$v
                          },
                          expression: "ExtractDataFromCertificat",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.ExtractDataFromHeader !== "" && _vm.tb != "1"
        ? _c(
            "form-accordion",
            {
              attrs: {
                title: _vm.$t("common.global.authentification_header"),
                isTitleUpperCase: false,
              },
            },
            [
              _c(
                "b-row",
                { staticClass: "form-group" },
                [
                  _c(
                    "b-col",
                    { staticClass: "form-group", attrs: { sm: "6" } },
                    [
                      _c("form-write-group-label-input", {
                        attrs: {
                          isMandatory: "",
                          disabled: _vm.readonly,
                          inputLabel: _vm.$t(
                            "common.routing.extract_data_from_header"
                          ),
                          placeholderValue: _vm.$t(
                            "common.routing.extract_data_from_header"
                          ),
                        },
                        model: {
                          value: _vm.ExtractDataFromHeader,
                          callback: function ($$v) {
                            _vm.ExtractDataFromHeader = $$v
                          },
                          expression: "ExtractDataFromHeader",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }